import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';

import Toggle from 'react-toggle';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import InputMask from 'react-input-mask';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';

import ScheduleGradeAircraftLineChanged from './Elements/ScheduleGradeAircraftLineChanged';
import ScheduleGradeAircraftLineChangedOriginalView from './Elements/ScheduleGradeAircraftLineChangedOriginalView';
import ScheduleGradeAircraftLine from './Elements/ScheduleGradeAircraftLine';
import ScheduleGradeAircraftLineAlternate from './Elements/ScheduleGradeAircraftLineAlternate';
import ScheduleGradeAircraftLineAlternateExtra from './Elements/ScheduleGradeAircraftLineAlternateExtra';
import ScheduleUsedRegimeEdit from './Elements/ScheduleUsedRegimeEdit';
import getLocale from '../../i18n/getLocale';


class ScheduleCvoEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      blocked_approval: 0,
      id: '',
      name: '',
      base: '',
      date_start: '',
      date_finish: '',
      fortnight_1_date_start: '',
      fortnight_1_date_finish: '',
      fortnight_2_date_start: '',
      fortnight_2_date_finish: '',
      schedule_grades: [],
      schedule_grade: {},
      grade: {},
      schedule_changes: 0,
      change_days: null,
      change_days_without_aircraft: null,
      line_staffs_changed: {},
      removed_aircrafts: {},
      removed_bases: {},
      removed_staffs: {},
      new_aircrafts: {},
      new_bases: {},
      new_staffs: {},
      grade_alternate: {},
      initials_colors: {},
      schedule_days: {},
      modal: false,
      modal_alert: false,
      alerts: {},
      verification: 0,
      signing: 0,
      schedule_used_regimes: [],
      schedule_regimes_escala: [],
      schedule_regimes_mestre: [],
      schedule_regimes_cvo: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.edit = this.edit.bind(this);
    this.loadData = this.loadData.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeModalAlert = this.closeModalAlert.bind(this);
    this.closeModalAlertOfficialize = this.closeModalAlertOfficialize.bind(this);
    this.getInfoEscala = this.getInfoEscala.bind(this);
    this.exportCsv = this.exportCsv.bind(this);
    this.viewAlerts = this.viewAlerts.bind(this);
    this.openObservationsInput = this.openObservationsInput.bind(this);
    this.officialize = this.officialize.bind(this);
    this.verify = this.verify.bind(this);
    this.approve = this.approve.bind(this);
    this.duplicate = this.duplicate.bind(this);
    this.deleteGrade = this.deleteGrade.bind(this);
    this.exportPdfGrade = this.exportPdfGrade.bind(this);
    this.exportPdfRevisionGrade = this.exportPdfRevisionGrade.bind(this);
    this.addScheduleUsedRegime = this.addScheduleUsedRegime.bind(this);
    this.refreshScheduleRegimes = this.refreshScheduleRegimes.bind(this);
    this.export = this.export.bind(this);
    this.blockApproval = this.blockApproval.bind(this);
    this.unblockApproval = this.unblockApproval.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  } 

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData(1));
    }
  }

  loadData (first_load) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/sigla/modelos');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.main.id,
            blocked_approval: responseJson.data.main.blocked_approval,
            name: responseJson.data.main.name,
            base: responseJson.data.main.base.name,
            date_start: responseJson.data.main.date_start_start_str,
            date_finish: responseJson.data.main.date_finish_start_str,
            fortnight_1_date_start: responseJson.data.main.fortnight_1_date_start_str,
            fortnight_1_date_finish: responseJson.data.main.fortnight_1_date_finish_str,
            fortnight_2_date_start: responseJson.data.main.fortnight_2_date_start_str,
            fortnight_2_date_finish: responseJson.data.main.fortnight_2_date_finish_str,
            next_schedule_id: responseJson.data.next_schedule_id,
            previous_schedule_id: responseJson.data.previous_schedule_id,
            schedule_used_regimes: responseJson.data.schedule_used_regimes,
            schedule_regimes_escala: responseJson.data.schedule_regimes_escala,
            schedule_regimes_mestre: responseJson.data.schedule_regimes_mestre,
            schedule_regimes_cvo: responseJson.data.schedule_regimes_cvo,
          });
        }
      }).then(() => {
      var url = config.get('api') + '/escala/grades/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({schedule_grades: responseJson.data});
        }
      }).then(() => {
        if(first_load === 1) {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          self.handleMessage();
        }
      }); /* Overlay */ }); /* ScheduleGrades */
    });
  }

  refreshGrades (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/grades/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({schedule_grades: responseJson.data});
        }
      }).then(() => {
        self.handleAlert(event.message, event.status, 'open');
      }); /* Overlay */
    });
  }

  refreshScheduleRegimes (event) {
    this.setState({schedule_used_regimes: event.data});
  }
  
  //Envia email com somatório de diárias de cada tripulante
  exportCsv(event) {
    var url = "/escala/grade/exportar/diarias/" + event;
    var self = this;
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        }
      });
    });
  }
  
  // Tento oficializar a escala
  officialize (schedule_grade_id) {
    var self = this;
    if (window.confirm(this.locale.Escalas.EditarEscalaCVODVO.efetivarGrade)) {
      self.setState({overlay: {message: '', type: '', status: 'open'}});
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        var url = config.get('api') + '/efetivar/escala/' + self.props.match.params.id + '/' + schedule_grade_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.loadData(0);
            self.handleAlert(responseJson.message, responseJson.status, 'open');
            window.open(config.get('cdn') + '/schedule_grades/main/' + responseJson.data);
          } else {
            self.setState({alerts: responseJson.data});
            self.handleAlert(responseJson.message, responseJson.status, 'open');
            self.setState({modal_alert_officialize: true});
          }
        });
      });
    }
  }
  
  // abrimos input de observações
  openObservationsInput(schedule_grade_id) {
    var data = this.state.schedule_grades;
    data.map(function(dado, index){
      if (dado.id == schedule_grade_id) {
        if (data.input_on == 1) {
          data.input_on = 0;
        } else {
          data.input_on = 1;
        }
      }
    });
    this.setState({schedule_grades: data});
  }
  // gero os dados do modal de alertas da grade
  viewAlerts (schedule_grade_id) {
    var self = this;
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/gerar/alertas/' + self.props.match.params.id + '/' + schedule_grade_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({alerts: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.setState({modal_alert: true});
      })
    });
  }
  
  // gero os dados do modal de visualização da escala
  getInfoEscala (schedule_grade_id) {
    var self = this;
    self.setState({schedule_changes: 0});          
    self.setState({change_days: null});          
    self.setState({line_staffs_changed: null});
    self.setState({removed_aircrafts: null});
    self.setState({removed_bases: null});
    self.setState({removed_staffs: null});
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/grade/aeronaves/escaladas/' + schedule_grade_id + '/1';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/sigla/modelos');
        if (responseJson.status === 'success') {
          if (responseJson.data.schedule_changes) {
            self.setState({schedule_changes: 1});          
            self.setState({change_days_without_aircraft: responseJson.data.schedule_changes.change_days_without_aircraft});          
            self.setState({change_days: responseJson.data.schedule_changes.change_days});          
            self.setState({line_staffs_changed: responseJson.data.schedule_changes.line_staffs_changed});
            self.setState({removed_aircrafts: responseJson.data.schedule_changes.removed_aircrafts});
            self.setState({removed_bases: responseJson.data.schedule_changes.removed_bases});
            self.setState({removed_staffs: responseJson.data.schedule_changes.removed_staffs});
            self.setState({new_aircrafts: responseJson.data.schedule_changes.new_aircrafts});
            self.setState({new_bases: responseJson.data.schedule_changes.new_bases});
            self.setState({new_staffs: responseJson.data.schedule_changes.new_staffs});
          }
          self.setState({grade: responseJson.data.main});
          self.setState({grade_extra_main: responseJson.data.extra_main});
          self.setState({grade_alternate: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/escala/grade/info/' + schedule_grade_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          if(responseJson.data.warning === 1) {
            self.setState({error_schedule_pendencies_ids: responseJson.data.error_schedule_pendencies_ids});
            self.setState({errors_listing: true});
          }
          self.setState({schedule_grade: responseJson.data.schedule_grade});
        }
      }).then(() => {
      var url = config.get('api') + '/escala/dias/' + schedule_grade_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({schedule_days: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/siglas/cores';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({initials_colors: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.setState({modal: true});
      }); /* Overlay */ }); /* info grade */ }); /* dias grade */ }); /* cores iniciais */
    });
  }

  // Modal para marcar como verificada
  verify(schedule_grade_id){
    this.setState({verification: 1});
    this.getInfoEscala(schedule_grade_id);
  }

  // Modal para marcar como verificada
  confirmVerify(schedule_grade_id){
    var confirm = window.confirm(this.locale.Escalas.EditarEscalaCVODVO.trocarStatusDessaGradeParaVerificada);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: schedule_grade_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/verificar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.loadData(0);
          self.closeModal();
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Modal para marcar como verificada
  confirmSign(schedule_grade_id){
    var confirm = window.confirm(this.locale.Escalas.EditarEscalaCVODVO.trocarStatusDessaGradeParaAprovada);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: schedule_grade_id,
        type: 'cvo',
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/aprovar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.loadData(0);
          self.closeModal();
          self.handleAlert(responseJson.message, responseJson.status, 'open');
          if(responseJson.status === 'success') {
            // window.open(config.get('cdn') + '/schedule_grades/main/' + responseJson.data);
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }
  // Modal para marcar como verificada
  repproveGrade(schedule_grade_id){
    var confirm = window.confirm(this.locale.Escalas.EditarEscalaCVODVO.trocarStatusDessaGradeParaRascunho);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: schedule_grade_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/reprovar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.loadData(0);
          self.closeModal();
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Modal para marcar como verificada
  duplicate(schedule_grade_id){
    var confirm = window.confirm(this.locale.Escalas.EditarEscalaCVODVO.criarRevisaoDestaGrade);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: schedule_grade_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/duplicar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.loadData(0);
          self.closeModal();
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  //Gerar pdf
  exportPdfRevisionGrade(event) {
    var schedule_grade_id = event.currentTarget.value;
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/exportar/pdf/escala-grade/cvo/' + schedule_grade_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.refreshGrades(responseJson);
        window.open(config.get('cdn') + '/schedule_grades/main/' + responseJson.data);       
      })
    });
  }
  
  exportPdfGrade(event) {
    var schedule_grade_id = event.currentTarget.value;
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/exportar/pdf/escala-grade/cvo/' + schedule_grade_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.refreshGrades(responseJson);
        window.open(config.get('cdn') + '/schedule_grades/main/' + responseJson.data);       
      })
    });
  }
  
  // Modal para marcar como verificada
  approve(schedule_grade_id){
    this.setState({signing: 1});
    this.getInfoEscala(schedule_grade_id);
  }

  // Fecha modal
  closeModal(event){
    this.setState({modal: false, grade: [], grade_alternate: [], schedule_grade: {}, verification: 0, signing: 0});
  }
  // Fecha modal
  closeModalAlert(event){
    this.setState({modal_alert: false, alerts: {}});
  }

  // Fecha modal
  closeModalAlertOfficialize(event){
    this.setState({modal_alert_officialize: false, alerts: {}});
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      fortnight_1_date_start: this.state.fortnight_1_date_start,
      fortnight_1_date_finish: this.state.fortnight_1_date_finish,
      fortnight_2_date_start: this.state.fortnight_2_date_start,
      fortnight_2_date_finish: this.state.fortnight_2_date_finish,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  deleteGrade (event) {
    var schedule_grade_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Escalas.EditarEscalaCVODVO.deletarFrota);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/' + schedule_grade_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.refreshGrades(responseJson);
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  addScheduleUsedRegime (event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      schedule_id: this.state.id,
      schedule_regime_id: this.state.schedule_regime_id,
      start_day: this.state.start_day,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/uso/regime', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
        if (responseJson.status === 'success') {
          self.setState({schedule_used_regimes: responseJson.data});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  blockApproval(event) {
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/bloquear/' + self.state.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({blocked_approval: responseJson.data.blocked_approval});
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      })
    });
  }

  unblockApproval(event) {
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/desbloquear/' + self.state.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({blocked_approval: responseJson.data.blocked_approval});
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      })
    });
  }

  export(event) {
    var schedule_grade_id = event.currentTarget.value;
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/exportacao/escala/viagem/' + schedule_grade_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        window.open(config.get('cdn') + '/tmp/' + responseJson.data);
      })
    });
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <div className="row">
        <div className="col-md-4">
          {this.state.previous_schedule_id ? 
            <a href={'/escala/cvo/editar/' + this.state.previous_schedule_id} className={'btn btn-primary'}>
              <i className="fa fa-fw fa-chevron-left"></i>
            </a>
            : 
            ""
          }
        </div>
        <div className="col-md-4">
          <h3 className="page-title text-center">{this.state.base} - {this.state.name} - {this.locale.Escalas.EditarEscalaCVODVO.tituloCVODVO}</h3>
        </div>
        <div className="col-md-4 text-right">
          {this.state.next_schedule_id ? 
            <a href={'/escala/cvo/editar/' + this.state.next_schedule_id} className={'btn btn-primary'}>
              <i className="fa fa-fw fa-chevron-right"></i>
            </a>
            : 
            ""
          }
        </div>
      </div>
      <hr/>
      <h3 className="page-title pull-left">{this.locale.Escalas.EditarEscalaCVODVO.titulo} - {this.state.base} - {this.state.name}</h3>
      <Link to="/escalas/cvo" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      {this.state.blocked_approval === 0 ? 
        <button onClick={self.blockApproval} className="pull-right btn btn-danger button-inline" value={self.state.id}><i className="fa fa-fw fa-warning"></i> {this.locale.Escalas.EditarEscalaCVODVO.botaoBloquearEscala}</button>
        : 
        <button onClick={self.unblockApproval} className="pull-right btn btn-success button-inline" value={self.state.id}><i className="fa fa-fw fa-warning"></i> {this.locale.Escalas.EditarEscalaCVODVO.botaoDesbloquearEscala}</button>
      }
      <div className="clearfix"></div>
      <hr/>
      <h3 className="page-title">{this.locale.Escalas.EditarEscalaCVODVO.tituloGrades}</h3>
      <hr/>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th className="col-md-2 text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaGrades.Revisao}</th>
            <th className="col-md-2 text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaGrades.Status}</th>
            <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaGrades.Efetivacao}</th>
            <th className="col-md-6 text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaGrades.Acoes}</th>
          </tr>
        </thead>
        <tbody id="suppliers-certifications">
          {Object.keys(self.state.schedule_grades).map(function(k) {
            return (
              <tr>
                <td className="text-center">{self.state.schedule_grades[k].revision}</td>
                <td className="text-center">{self.state.schedule_grades[k].status_str}</td>
                <td>{self.state.schedule_grades[k].partial === 1 ? 'Efetivação Parcial' : self.state.schedule_grades[k].official === 1 ? "Efetivada" : ""}</td>
                <td className="text-center">
                  {(self.state.schedule_grades[k].status === 'draft') ?  
                    <div>
                      <button className="btn btn-default button-inline" onClick={() => self.getInfoEscala(self.state.schedule_grades[k].id)}><i className="fa fa-fw fa-eye"></i></button>
                      <button onClick={self.exportPdfRevisionGrade} className="btn btn-warning button-inline" value={self.state.schedule_grades[k].id}><i className="fa fa-fw fa-file-pdf-o"></i> {self.locale.Escalas.EditarEscalaCVODVO.tabelaGrades.botaoGerarPDF}</button>
                      <Link to={"/escala/alternativa/grade/" + self.state.schedule_grades[k].id} className="btn btn-success button-inline" ><i className="fa fa-fw fa-pencil"></i> {self.locale.general.editar}</Link>
                      <button className="btn btn-primary button-inline" value={self.state.schedule_grades[k].id} onClick={() => self.verify(self.state.schedule_grades[k].id)}><i className="fa fa-fw fa-check"></i> {self.locale.Escalas.EditarEscalaCVODVO.tabelaGrades.botaoMarcarComoVerificada}</button>
                      <button className="btn btn-warning button-inline" onClick={() => { self.viewAlerts(self.state.schedule_grades[k].id) }}><i className="fa fa-fw fa-warning"></i> {self.locale.Escalas.EditarEscalaCVODVO.tabelaGrades.botaoRelatorioDeAlertas}</button>
                      <button className="btn btn-danger button-inline" value={self.state.schedule_grades[k].id} onClick={self.deleteGrade}><i className="fa fa-fw fa-trash"></i></button>
                    </div>
                    : ''
                  }
                  {(self.state.schedule_grades[k].status === 'verified') ?  
                    <div>
                      <button className="btn btn-default button-inline" onClick={() => self.getInfoEscala(self.state.schedule_grades[k].id)}><i className="fa fa-fw fa-eye"></i></button>
                      <button className="btn btn-primary button-inline" value={self.state.schedule_grades[k].id} onClick={() => self.approve(self.state.schedule_grades[k].id)}><i className="fa fa-fw fa-check"></i> {self.locale.Escalas.EditarEscalaCVODVO.tabelaGrades.botaoMarcarComoAprovada}</button>
                      <button className="btn btn-warning button-inline" onClick={() => { self.viewAlerts(self.state.schedule_grades[k].id) }}><i className="fa fa-fw fa-warning"></i> {self.locale.Escalas.EditarEscalaCVODVO.tabelaGrades.botaoRelatorioDeAlertas}</button>
                    </div>
                    : ''
                  }
                  {(self.state.schedule_grades[k].status === 'approved') ?  
                    <div>
                      <button className="btn btn-default button-inline" onClick={() => self.getInfoEscala(self.state.schedule_grades[k].id)}><i className="fa fa-fw fa-eye"></i></button>
                      <button className="btn btn-primary button-inline" value={self.state.schedule_grades[k].id} onClick={() => self.duplicate(self.state.schedule_grades[k].id)}><i className="fa fa-fw fa-refresh"></i> {self.locale.Escalas.EditarEscalaCVODVO.tabelaGrades.botaoCriarRevisao}</button>
                      <button onClick={self.export} className="btn btn-success button-inline" value={self.state.schedule_grades[k].id}><i className="fa fa-plane"></i></button>
                      <button onClick={self.exportPdfGrade} className="btn btn-warning button-inline" value={self.state.schedule_grades[k].id}><i className="fa fa-fw fa-file-pdf-o"></i> {self.locale.Escalas.EditarEscalaCVODVO.tabelaGrades.botaoGerarPDF}</button>
                      <button className="btn btn-info button-inline" onClick={() => self.openObservationsInput(self.state.schedule_grades[k].id)}><i className="fa fa-fw fa-align-left"></i></button>
                      <button className="btn btn-warning button-inline" onClick={() => { self.viewAlerts(self.state.schedule_grades[k].id) }}><i className="fa fa-fw fa-warning"></i> {self.locale.Escalas.EditarEscalaCVODVO.tabelaGrades.botaoRelatorioDeAlertas}</button>
                      {(self.state.schedule_grades[k].official === 1 && self.state.schedule_grades[k].partial === 1) ? 
                        <button className="btn btn-primary button-inline" onClick={() => { self.officialize(self.state.schedule_grades[k].id) }}><i className="fa fa-fw fa-check"></i> {self.locale.Escalas.EditarEscalaCVODVO.tabelaGrades.botaoEfetivar}</button>
                        : (self.state.schedule_grades[k].official === 1) ?
                        <button className="btn btn-primary button-inline" disabled><i className="fa fa-fw fa-check"></i> {self.locale.Escalas.EditarEscalaCVODVO.tabelaGrades.botaoEscalaEfetivada}</button>
                        :
                        <button className="btn btn-primary button-inline" onClick={() => { self.officialize(self.state.schedule_grades[k].id) }}><i className="fa fa-fw fa-check"></i> {self.locale.Escalas.EditarEscalaCVODVO.tabelaGrades.botaoEfetivar}</button>
                      }
                      {(self.state.schedule_grades[k].input_on === 1) ? 
                        <textarea style={{ height: 200 }} type="text" name="observations" className="form-control" value={self.state.schedule_grades[k].id} onChange={this.handleChange.bind(this, 'observations')} />
                        : ''
                      }
                    </div>
                    : ''
                  }
                  {(self.state.schedule_grades[k].status === 'deprecated') ?  
                    <div>
                      <button className="btn btn-default button-inline" onClick={() => self.getInfoEscala(self.state.schedule_grades[k].id)}><i className="fa fa-fw fa-eye"></i></button>
                      <button onClick={self.exportPdfGrade} className="btn btn-warning button-inline" value={self.state.schedule_grades[k].id}><i className="fa fa-fw fa-file-pdf-o"></i> {self.locale.Escalas.EditarEscalaCVODVO.tabelaGrades.botaoGerarPDF}</button>
                      <button className="btn btn-warning button-inline" onClick={() => { self.viewAlerts(self.state.schedule_grades[k].id) }}><i className="fa fa-fw fa-warning"></i> {self.locale.Escalas.EditarEscalaCVODVO.tabelaGrades.botaoRelatorioDeAlertas}</button>
                    </div>
                    : ''
                  }
                  {(self.state.schedule_grades[k].status === 'approving') ?  
                    <div>
                      <span className="label label-danger">{self.locale.Escalas.EditarEscalaCVODVO.tabelaGrades.EstamosProcessandoAAprovacao}</span>
                    </div>
                    : ''
                  }
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <hr/>
      <h4>{this.locale.Escalas.EditarEscalaCVODVO.tituloRegimesDeTrabalho}</h4>
      <hr/>
      <form onSubmit={this.addScheduleUsedRegime}>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Escalas.EditarEscalaCVODVO.formularioRegimesDeTrabalho.Regime}:</label>
              <Select
                className="form-field-name"
                name="schedule_regime_id"
                value={this.state.schedule_regime_id}
                searchable={true}
                placeholder={this.locale.Escalas.EditarEscalaCVODVO.formularioRegimesDeTrabalho.placeholder.SelecioneORegime}
                onChange={this.handleSelectChange.bind(this, 'schedule_regime_id')}
                options={this.state.schedule_regimes_cvo}
              />    
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Escalas.EditarEscalaCVODVO.formularioRegimesDeTrabalho.DataDeInicio}:</label>
              <InputMask value={this.state.start_day}  maskChar={null} name="start_day" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'start_day')} placeholder="" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <button type="submit" className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i> {this.locale.general.salvar}</button>
            </div>
          </div>
        </div>
      </form>
      <hr/>
      <h4>{this.locale.Escalas.EditarEscalaCVODVO.tituloRegimesEmUso}</h4>
      <hr/>
      {(this.state.schedule_used_regimes === null || typeof this.state.schedule_used_regimes === 'undefined') ?  '' 
      : 
        <table className="table">
          <thead>
            <tr>
              <th>
                {this.locale.Escalas.EditarEscalaCVODVO.tabelaRegimesEmUso.ID}
              </th>
              <th>
                {this.locale.Escalas.EditarEscalaCVODVO.tabelaRegimesEmUso.Regime}
              </th>
              <th>
                {this.locale.Escalas.EditarEscalaCVODVO.tabelaRegimesEmUso.DataDeInicio}
              </th>
              <th>{this.locale.Escalas.EditarEscalaCVODVO.tabelaRegimesEmUso.Acoes}</th>
            </tr>
          </thead>
          <tbody id="suppliers-certifications">
            {Object.keys(self.state.schedule_used_regimes).map(function(k) {
              return (
                <ScheduleUsedRegimeEdit
                  id={self.state.schedule_used_regimes[k].id}
                  schedule_regime={self.state.schedule_used_regimes[k].schedule_regime.name}
                  start_day={self.state.schedule_used_regimes[k].start_day_str}
                  handleAlert={self.handleAlert}
                  refreshScheduleRegimes={self.refreshScheduleRegimes}
                />
              );
            })}
          </tbody>
        </table>
      }
    </div>
  </div>
  <Modal show={this.state.modal_alert_officialize} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">{this.locale.Escalas.EditarEscalaCVODVO.tituloRevisao} {self.state.schedule_grade.revision} - {this.state.base} - {this.state.name} - <strong>{this.locale.Escalas.EditarEscalaCVODVO.tituloAlertasImpeditivos}</strong></h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModalAlertOfficialize}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
    {
      (typeof self.state.alerts.global_alerts !== 'undefined') ?
      <div>
        {Object.keys(self.state.alerts.global_alerts).map(function(k) {
          var alert = self.state.alerts.global_alerts[k];
          if (alert.status === 'danger' && (alert.official === 1 || alert.exception === 1)) {
            return(
              <div className={"box-alert box-alert-" + alert.color}>
                <h4><strong>{alert.title}</strong></h4>
                  <div dangerouslySetInnerHTML={{__html: alert.message}}></div>
              </div>
            );
          } else {
            return(
              ''
            );
          }
        })}
        <hr/>
      </div>
      :
      ''
    }
    {
      (typeof self.state.alerts.personal_alerts !== 'undefined') ?
      <div>
        {Object.keys(self.state.alerts.personal_alerts).map(function(nickname) {
          var alerts = self.state.alerts.personal_alerts[nickname];
          return(
            <div>
              <h4><strong>{nickname}</strong></h4>
              {Object.keys(alerts).map(function(k) {
                var alert = alerts[k];
                if (alert.status === 'danger' && (alert.official === 1 || alert.exception === 1)) {
                  return(
                    <div className={"box-alert box-alert-" + alert.color}>
                        <div dangerouslySetInnerHTML={{__html: alert.message}}></div>
                    </div>
                  );
                } else {
                  return(
                    ''
                  );
                }
              })}
              <hr/>
            </div>
          );
        })}
      </div>
      :
      ''
    }

    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModalAlertOfficialize}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
  <Modal show={this.state.modal_alert} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">{this.locale.Escalas.EditarEscalaCVODVO.tituloRevisao} {self.state.schedule_grade.revision} - {this.state.base} - {this.state.name}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModalAlert}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
    {
      (typeof self.state.alerts.global_alerts !== 'undefined') ?
      <div>
        {Object.keys(self.state.alerts.global_alerts).map(function(k) {
          var alert = self.state.alerts.global_alerts[k];
          if (alert.status === 'danger') {
            return(
              <div className={"box-alert box-alert-" + alert.color}>
                <h4><strong>{alert.title}</strong></h4>
                  <div dangerouslySetInnerHTML={{__html: alert.message}}></div>
              </div>
            );
          } else {
            return(
              ''
            );
          }
        })}
        <hr/>
      </div>
      :
      ''
    }
    {
      (typeof self.state.alerts.personal_alerts !== 'undefined') ?
      <div>
        {Object.keys(self.state.alerts.personal_alerts).map(function(nickname) {
          var alerts = self.state.alerts.personal_alerts[nickname];
          return(
            <div>
              <h4><strong>{nickname}</strong></h4>
              {Object.keys(alerts).map(function(k) {
                var alert = alerts[k];
                if (alert.status === 'danger') {
                  return(
                    <div className={"box-alert box-alert-" + alert.color}>
                        <div dangerouslySetInnerHTML={{__html: alert.message}}></div>
                    </div>
                  );
                } else {
                  return(
                    ''
                  );
                }
              })}
              <hr/>
            </div>
          );
        })}
      </div>
      :
      ''
    }

    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModalAlert}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
  <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">{this.locale.Escalas.EditarEscalaCVODVO.tituloRevisao} {self.state.schedule_grade.revision} - {this.state.base} - {this.state.name}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
      {this.state.errors_listing &&
        <div className="alert alert-danger alert-dismissible" role="alert" style={{marginTop: 25}}>
          <button onClick={() => self.setState({ errors_listing: false, error_schedule_pendencies_ids: [], })} type="button" className="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>{this.locale.Escalas.EditarEscalaCVODVO.existemAsSeguintesPendencias}:</strong>
          {Object.keys(self.state.error_schedule_pendencies_ids).map(function(k) {
            var id = self.state.error_schedule_pendencies_ids[k];
            return (
              <p>ID - {id}</p>
            );
          })}
        </div>
      }
    </Modal.Header>
    <Modal.Body>
      {(self.state.verification === 1) ?  
        <div>
          <button className="btn btn-primary btn-block btn-lg" onClick={() => self.confirmVerify(self.state.schedule_grade.id)}><i className="fa fa-fw fa-check"></i> {this.locale.Escalas.EditarEscalaCVODVO.botaoConfirmarMudancaDeStatusParaVerificada}</button>
          <hr/>
        </div> 
      : ""
      }
      {(self.state.signing === 1) ?  
        <div>
          <button className="btn btn-warning btn-block btn-lg" onClick={() => self.repproveGrade(self.state.schedule_grade.id)}><i className="fa fa-fw fa-left"></i> {this.locale.Escalas.EditarEscalaCVODVO.botaoVoltarParaRascunho}</button>
          <button className="btn btn-primary btn-block btn-lg" onClick={() => self.confirmSign(self.state.schedule_grade.id)}><i className="fa fa-fw fa-check"></i> {this.locale.Escalas.EditarEscalaCVODVO.botaoAprovarEscala}</button>
          <hr/>
        </div> 
      : ""
      }
      {(this.state.grade_alternate === null || typeof this.state.grade_alternate === 'undefined') ?  '' 
      : 
        <div>
          {(this.state.grade_alternate.ALTERNATE !== null && typeof this.state.grade_alternate.ALTERNATE !== 'undefined') ?  
            <div className="table-schedule-container-simple">
              <hr/>
              <h3 className="page-title">{this.locale.Escalas.EditarEscalaCVODVO.tituloEscala}</h3>
              <hr/>
              <table className="table table-schedule table-bordered">
                <thead>
                  <tr>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaEscala.Nome}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaEscala.Matricula}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaEscala.Funcao}</th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.weekday}</th>
                      );
                    })}
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.day_simple}</th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody id="suppliers-certifications">
                  {Object.keys(self.state.grade_alternate.ALTERNATE).map(function(k) {
                    var sgas = self.state.grade_alternate.ALTERNATE[k];
                    return(
                      <ScheduleGradeAircraftLineAlternate schedule_days={self.state.schedule_days} initials_colors={self.state.initials_colors} sgas={sgas} />
                    );
                  })}
                </tbody>
              </table>
              <hr/>
            </div>
          : ''
          }
          {(this.state.grade_alternate.INS !== null && typeof this.state.grade_alternate.INS !== 'undefined') ?  
            <div className="table-schedule-container-simple">
              <hr/>
              <h3 className="page-title">{this.locale.Escalas.EditarEscalaCVODVO.tituloInstrucao}</h3>
              <hr/>
              <table className="table table-schedule table-bordered">
                <thead>
                  <tr>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaInstrucao.Nome}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaInstrucao.Matricula}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaInstrucao.Designacao}</th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.weekday}</th>
                      );
                    })}
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.day_simple}</th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody id="suppliers-certifications">
                  {Object.keys(self.state.grade_alternate.INS).map(function(k) {
                    var sgas = self.state.grade_alternate.INS[k];
                    return(
                      <ScheduleGradeAircraftLineAlternate schedule_days={self.state.schedule_days} initials_colors={self.state.initials_colors} sgas={sgas} />
                    );
                  })}
                </tbody>
              </table>
              <hr/>
            </div>
          : ''
          }
          {(this.state.grade_alternate.EQUIP !== null && typeof this.state.grade_alternate.EQUIP !== 'undefined') ?  
            <div className="table-schedule-container-simple">
              <hr/>
              <h3 className="page-title">{this.locale.Escalas.EditarEscalaCVODVO.tituloChefeDeEquipamento}</h3>
              <hr/>
              <table className="table table-schedule table-bordered">
                <thead>
                  <tr>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaChefeDeEquipamento.Nome}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaChefeDeEquipamento.Matricula}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaChefeDeEquipamento.Designacao}</th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.weekday}</th>
                      );
                    })}
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.day_simple}</th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody id="suppliers-certifications">
                  {Object.keys(self.state.grade_alternate.EQUIP).map(function(k) {
                    var sgas = self.state.grade_alternate.EQUIP[k];
                    return(
                      <ScheduleGradeAircraftLineAlternate schedule_days={self.state.schedule_days} initials_colors={self.state.initials_colors} sgas={sgas} />
                    );
                  })}
                </tbody>
              </table>
              <hr/>
            </div>
          : ''
          }
          {(this.state.grade_alternate.MEDICA !== null && typeof this.state.grade_alternate.MEDICA !== 'undefined') ?  
            <div className="table-schedule-container-simple">
              <hr/>
              <h3 className="page-title">{this.locale.Escalas.EditarEscalaCVODVO.tituloDispensaMedica}</h3>
              <hr/>
              <table className="table table-schedule table-bordered">
                <thead>
                  <tr>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaDispensaMedica.Nome}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaDispensaMedica.Matricula}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaDispensaMedica.Designacao}</th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.weekday}</th>
                      );
                    })}
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.day_simple}</th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody id="suppliers-certifications">
                  {Object.keys(self.state.grade_alternate.MEDICA).map(function(k) {
                    var sgas = self.state.grade_alternate.MEDICA[k];
                    return(
                      <ScheduleGradeAircraftLineAlternate schedule_days={self.state.schedule_days} initials_colors={self.state.initials_colors} sgas={sgas} />
                    );
                  })}
                </tbody>
              </table>
              <hr/>
            </div>
          : ''
          }
          {(this.state.grade_alternate.MANUT !== null && typeof this.state.grade_alternate.MANUT !== 'undefined') ?  
            <div className="table-schedule-container-simple">
              <hr/>
              <h3 className="page-title">{this.locale.Escalas.EditarEscalaCVODVO.tituloManutencao}</h3>
              <hr/>
              <table className="table table-schedule table-bordered">
                <thead>
                  <tr>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaManutencao.Nome}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaManutencao.Matricula}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaManutencao.Designacao}</th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.weekday}</th>
                      );
                    })}
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.day_simple}</th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody id="suppliers-certifications">
                  {Object.keys(self.state.grade_alternate.MANUT).map(function(k) {
                    var sgas = self.state.grade_alternate.MANUT[k];
                    return(
                      <ScheduleGradeAircraftLineAlternate schedule_days={self.state.schedule_days} initials_colors={self.state.initials_colors} sgas={sgas} />
                    );
                  })}
                </tbody>
              </table>
              <hr/>
            </div>
          : ''
          }
          {(this.state.grade_alternate.FERIAS !== null && typeof this.state.grade_alternate.FERIAS !== 'undefined') ?  
            <div className="table-schedule-container-simple">
              <hr/>
              <h3 className="page-title">{this.locale.Escalas.EditarEscalaCVODVO.tituloFerias}</h3>
              <hr/>
              <table className="table table-schedule table-bordered">
                <thead>
                  <tr>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaFerias.Nome}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaFerias.Matricula}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaFerias.Designacao}</th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.weekday}</th>
                      );
                    })}
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.day_simple}</th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody id="suppliers-certifications">
                  {Object.keys(self.state.grade_alternate.FERIAS).map(function(k) {
                    var sgas = self.state.grade_alternate.FERIAS[k];
                    return(
                      <ScheduleGradeAircraftLineAlternate schedule_days={self.state.schedule_days} initials_colors={self.state.initials_colors} sgas={sgas} />
                    );
                  })}
                </tbody>
              </table>
              <hr/>
            </div>
          : ''
          }
          {(this.state.grade_alternate.FORA !== null && typeof this.state.grade_alternate.FORA !== 'undefined') ?  
            <div className="table-schedule-container-simple">
              <hr/>
              <h3 className="page-title">{this.locale.Escalas.EditarEscalaCVODVO.tituloForaDeEscala}</h3>
              <hr/>
              <table className="table table-schedule table-bordered">
                <thead>
                  <tr>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaForaDeEscala.Nome}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaForaDeEscala.Matricula}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaForaDeEscala.Designacao}</th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.weekday}</th>
                      );
                    })}
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.day_simple}</th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody id="suppliers-certifications">
                  {Object.keys(self.state.grade_alternate.FORA).map(function(k) {
                    var sgas = self.state.grade_alternate.FORA[k];
                    return(
                      <ScheduleGradeAircraftLineAlternate schedule_days={self.state.schedule_days} initials_colors={self.state.initials_colors} sgas={sgas} />
                    );
                  })}
                </tbody>
              </table>
              <hr/>
            </div>
          : ''
          }
          
        </div>
      }
      {(self.state.schedule_changes === 1) ?
        <div>
          <hr/>
          <h3 className="page-title">{this.locale.Escalas.EditarEscalaCVODVO.tituloAlteracoesNaEscala}</h3>
          {(self.state.removed_bases === null || typeof self.state.removed_bases === 'undefined') ?  '' 
          : 
            <div className="table-schedule-container">     
              <hr/>
              {Object.keys(self.state.removed_bases).map(function(k) {
                var rb = self.state.removed_bases[k];
                return(
                  <p>{rb}</p>
                );
              })}
            </div>
          }
          {(self.state.new_bases === null || typeof self.state.new_bases === 'undefined') ?  '' 
          : 
            <div className="table-schedule-container">     
              <hr/>
              {Object.keys(self.state.new_bases).map(function(k) {
                var nb = self.state.new_bases[k];
                return(
                  <p>{nb}</p>
                );
              })}
            </div>
          }
          {(self.state.removed_aircrafts === null || typeof self.state.removed_aircrafts === 'undefined') ?  '' 
          : 
            <div className="table-schedule-container">     
              <hr/>
              {Object.keys(self.state.removed_aircrafts).map(function(k) {
                var ra = self.state.removed_aircrafts[k];
                return(
                  <p>{ra}</p>
                );
              })}
            </div>
          }
          {(self.state.new_aircrafts === null || typeof self.state.new_aircrafts === 'undefined') ?  '' 
          : 
            <div className="table-schedule-container">     
              <hr/>
              {Object.keys(self.state.new_aircrafts).map(function(k) {
                var na = self.state.new_aircrafts[k];
                return(
                  <p>{na}</p>
                );
              })}
            </div>
          }
          {(self.state.removed_staffs === null || typeof self.state.removed_staffs === 'undefined') ?  '' 
          : 
            <div className="table-schedule-container">     
              <hr/>
              {Object.keys(self.state.removed_staffs).map(function(k) {
                var rs = self.state.removed_staffs[k];
                return(
                  <p>{rs}</p>
                );
              })}
            </div>
          }
          {(self.state.new_staffs === null || typeof self.state.new_staffs === 'undefined') ?  '' 
          : 
            <div className="table-schedule-container">     
              <hr/>
              {Object.keys(self.state.new_staffs).map(function(k) {
                var ns = self.state.new_staffs[k];
                return(
                  <p>{ns}</p>
                );
              })}
            </div>
          }
          {(self.state.line_staffs_changed === null || typeof self.state.line_staffs_changed === 'undefined') ?  '' 
          : 
            <div className="table-schedule-container">     
              <hr/>
              {Object.keys(self.state.line_staffs_changed).map(function(k) {
                var lsc = self.state.line_staffs_changed[k];
                return(
                  <p>{lsc}</p>
                );
              })}
            </div>
          }
          
          {(self.state.change_days_without_aircraft === null || typeof self.state.change_days_without_aircraft === 'undefined') ?  '' 
          : 
            <div className="table-schedule-container">     
              <hr/>
              {Object.keys(self.state.change_days_without_aircraft).map(function(k) {
                var sgas = self.state.change_days_without_aircraft[k];
                return(
                  <p>{sgas.days_changed_message}</p>
                );
              })}
            </div>
          }
          {(self.state.change_days_without_aircraft === null || typeof self.state.change_days_without_aircraft === 'undefined') ?  '' 
          : 
            <div className="table-schedule-container">     
              <hr/>
              <h3 className="page-title">{this.locale.Escalas.EditarEscalaCVODVO.tituloRevisaoAtual}</h3>
              <hr/>
              <table className="table table-schedule table-bordered">
                <thead>
                  <tr>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAtual.Base}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAtual.Aeronave}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAtual.Grupo}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAtual.Nome}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAtual.Matricula}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAtual.Designacao}</th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.weekday}</th>
                      );
                    })}
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.day_simple}</th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(self.state.change_days_without_aircraft).map(function(k) {
                    var sgas = self.state.change_days_without_aircraft[k];
                    return(
                      <ScheduleGradeAircraftLineChanged schedule_days={self.state.schedule_days} initials_colors={self.state.initials_colors} sgas={sgas} />
                    );
                  })}
                </tbody>
              </table>
              <hr/>
            </div>
          }
          {(self.state.change_days_without_aircraft === null || typeof self.state.change_days_without_aircraft === 'undefined') ?  <div><hr/><small><em>Nenhuma alteração nas subescalas de tripulantes.</em></small></div> 
          : 
            <div className="table-schedule-container">     
              <hr/>
              <h3 className="page-title">{this.locale.Escalas.EditarEscalaCVODVO.tituloRevisaoAnterior}</h3>
              <hr/>
              <table className="table table-schedule table-bordered">
                <thead>
                  <tr>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAnterior.Base}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAnterior.Aeronave}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAnterior.Grupo}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAnterior.Nome}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAnterior.Matricula}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAnterior.Designacao}</th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.weekday}</th>
                      );
                    })}
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.day_simple}</th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(self.state.change_days_without_aircraft).map(function(k) {
                    var sgas = self.state.change_days_without_aircraft[k];
                    return(
                      <ScheduleGradeAircraftLineChangedOriginalView schedule_days={self.state.schedule_days} initials_colors={self.state.initials_colors} sgas={sgas} />
                    );
                  })}
                </tbody>
              </table>
              <hr/>
            </div>
          }
          
          {(self.state.change_days === null || typeof self.state.change_days === 'undefined') ?  '' 
          : 
            <div className="table-schedule-container">     
              <hr/>
              {Object.keys(self.state.change_days).map(function(k) {
                var sgas = self.state.change_days[k];
                return(
                  <p>{sgas.days_changed_message}</p>
                );
              })}
            </div>
          }
          {(self.state.change_days === null || typeof self.state.change_days === 'undefined') ?  '' 
          : 
            <div className="table-schedule-container">     
              <hr/>
              <h3 className="page-title">{this.locale.Escalas.EditarEscalaCVODVO.tituloRevisaoAtual}</h3>
              <hr/>
              <table className="table table-schedule table-bordered">
                <thead>
                  <tr>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAtual.Base}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAtual.Aeronave}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAtual.Grupo}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAtual.Nome}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAtual.Matricula}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAtual.Designacao}</th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.weekday}</th>
                      );
                    })}
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.day_simple}</th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(self.state.change_days).map(function(k) {
                    var sgas = self.state.change_days[k];
                    return(
                      <ScheduleGradeAircraftLineChanged schedule_days={self.state.schedule_days} initials_colors={self.state.initials_colors} sgas={sgas} />
                    );
                  })}
                </tbody>
              </table>
              <hr/>
            </div>
          }
          {(self.state.change_days === null || typeof self.state.change_days === 'undefined') ?  <div><hr/><small><em>{this.locale.Escalas.EditarEscalaCVODVO.nenhumaAlteracaoNaEscalaPrincipal}</em></small></div> 
          : 
            <div className="table-schedule-container">     
              <hr/>
              <h3 className="page-title">{this.locale.Escalas.EditarEscalaCVODVO.tituloRevisaoAnterior}</h3>
              <hr/>
              <table className="table table-schedule table-bordered">
                <thead>
                  <tr>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAnterior.Base}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAnterior.Aeronave}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAnterior.Grupo}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAnterior.Nome}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAnterior.Matricula}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscalaCVODVO.tabelaRevisaoAnterior.Designacao}</th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.weekday}</th>
                      );
                    })}
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.day_simple}</th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(self.state.change_days).map(function(k) {
                    var sgas = self.state.change_days[k];
                    return(
                      <ScheduleGradeAircraftLineChangedOriginalView schedule_days={self.state.schedule_days} initials_colors={self.state.initials_colors} sgas={sgas} />
                    );
                  })}
                </tbody>
              </table>
              <hr/>
            </div>
          }
        </div>
        : ''
      }


    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={self.closeModal}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default ScheduleCvoEdit;



// WEBPACK FOOTER //
// ./src/Components/Schedules/ScheduleCvoEdit.js